<template>
  <div class="menu" >
    <div class="headWrap">

      <div :class="['menu_card', menuNeedOpacity?'needOpacity':'']">

        <div :class="size">
          <div>
            <el-divider></el-divider>
<!--            <ul class="infinite-list"   >-->


              <div  class="el-collapse-item__header menu_box-shadow" style="height: 40px;" @click="navigateToTargetPage('/')">
                <span style="padding-left: 10px">
               首页
               </span>
                <i data-v-5161d1db="" class="el-collapse-item__arrow el-icon-arrow-right"></i>
              </div>

              <div  class="el-collapse-item__header menu_box-shadow" style="height: 50px;" @click="navigateToTargetPage('/jobs')">
                <span style="padding-left: 10px">
               职位
               </span>
                <i data-v-5161d1db="" class="el-collapse-item__arrow el-icon-arrow-right"></i>
              </div>

<!--            </ul>-->
          </div>

        </div>
      </div>
    </div>
    <!--    <span @click="search" class="input-search-button">搜索</span>-->
  </div>
</template>
<script>
export default {
  name: "menu-Search",
  model: {
    event: "change"
  },
  props: {
    value: String,
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    }
  },
  methods: {
    search() {
      this.$emit("search", this.$refs.input.value);
    },
    navigateToTargetPage(url) {
      if(this.$route.path===url){
        window.location.reload()
      }

      this.$router.push(url);
    }
  }
};
</script>

<style lang="less" scoped>
.menu {
  //padding-left: -50px;
  .headWrap {
    background-color: seashell;
    margin-top: 386px;
    margin-left: -66px;
    position: fixed;
    display: flex;
    .menu_card {
      height: 160px;
      background-color: white;
      width: 435px;
      //margin-right: -50px;
      margin-top: -290px;
      .input-search {
        overflow: hidden;
        ::-webkit-input-placeholder {
          color: @secondary-text-color;
        }



        &.small {
          height: 40px;
          font-size: 14px;
        }

        &.large {
          height: 60px;
          font-size: 20px;
        }
        .prefix-icon {
          right: -2px;
          height: 40px;
          display: grid;
        }
        input {
          font-size: inherit;
          height: 100%;
          width: 100%;
          line-height: 100%;
          border: none;
          padding: 10px;
          padding-left: 2em;
        }
        &-button {
          padding: 9px;

          color: #fff;
          position: absolute;
          right: 0;

          top: 0;
          width: 100px;
          height: 100%;
          background: @main-color;
          display: flex;
          cursor: pointer;
          &:hover {
            // background: rgba(255, 255, 255, 0.5);
            &::before {
              transition: all 0.3s;
              content: "";
              position: absolute;
              width: 100%;
              top: -1px;
              bottom: -1px;
              background: rgba(255, 255, 255, 0.4);
            }
          }
        }
      }
    }

    .card h1 {
      color: #fff;
      text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    }

    .card p {
      color: #ddd;
    }
    .menu {
      margin-top: -100px;
      //opacity: 1.9;
      .menuCenter {
        //height: 80px;
        //width: 1200px;
        /* 设置一个半透明的背景色，可选 */
        background-color: rgba(255, 255, 255, 0.1);

        /* 应用模糊效果 */
        backdrop-filter: blur(10px);



      }
    }
    .menu.needOpacity {
      opacity: 0.8;
    }
  }
  .headBlank {
    //height: 110px;
    //width: 100%;
  }
}
/* 设置激活状态下的 router-link 链接颜色 */
/* 设置默认的 router-link 链接颜色 */
.router-link {
  color: #333; /* 未激活时的颜色，例如深灰色 */
  text-decoration: none; /* 移除默认的下划线 */
}

/* 设置激活状态下的 router-link 链接颜色 */
.router-link-active {
  color: #333; /* 激活时的颜色，例如橙色 */
  text-decoration: none; /* 可选：保持无下划线，或根据需要调整 */
}
/deep/.el-cascader-node__label{
  float: left;
  //padding: 0 -30px 0 20px;
  flex: -1;

}
/deep/.menu_box-shadow{
  background-color: #FFFFFF;
  font-size: 20px;
  color: #333333;
  font-weight: bold;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">-->
<!--  @import './pageTop.scss'-->
<!--</style>-->
